/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */

var nb = require('../../../nb');
module.exports = nb.define({
    parent: require('../../../Model'),
    mapping: {
        content:require('./Content')
    },
    method: {
        init: function () {
            var header = this.get('header');
            header.set('activeLi','index');
            this._checkPage();
        },
        _checkPage:function () {
            return false
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/Model.js
// module id = 401
// module chunks = 1